/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Transfer_Units_LabelInputs */

const en_us2_history_transfer_units_label = /** @type {(inputs: History_Transfer_Units_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Units in the Strong file`)
};

const pt_br2_history_transfer_units_label = /** @type {(inputs: History_Transfer_Units_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unidades do arquivo do Strong`)
};

const es_419_history_transfer_units_label = /** @type {(inputs: History_Transfer_Units_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unidades del archivo de Strong`)
};

const pt_pt2_history_transfer_units_label = /** @type {(inputs: History_Transfer_Units_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unidades do ficheiro do Strong`)
};

const fr_fr2_history_transfer_units_label = /** @type {(inputs: History_Transfer_Units_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unités du fichier Strong`)
};

const de_de2_history_transfer_units_label = /** @type {(inputs: History_Transfer_Units_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einheiten in der Strong-Datei`)
};

const it_it2_history_transfer_units_label = /** @type {(inputs: History_Transfer_Units_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unità del file di Strong`)
};

/**
* | output |
* | --- |
* | "Units in the Strong file" |
*
* @param {History_Transfer_Units_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_units_label = /** @type {((inputs?: History_Transfer_Units_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_Units_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_units_label(inputs)
	if (locale === "es-419") return es_419_history_transfer_units_label(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_units_label(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_units_label(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_units_label(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_units_label(inputs)
	return en_us2_history_transfer_units_label(inputs)
});
export { history_transfer_units_label as "history-transfer.units_label" }